import React from 'react'
import {  Statistic, Card } from 'antd';
import { Grid } from '@material-ui/core';


export const Statistics=({item})=> {
    return (
        <Grid item xs={12} sm={3}>
        <Card
            style={{ justifyItems:"center",background:item.background, fontSize: 25, color: 'white' }}
            title={<span>{item.Icon} {item.title}</span>} bordered={true}>
            <Statistic value={item.value} />
        </Card>
        </Grid>
    )
}

export default Statistics
